// @flow
import styles from './SearchResultHeader.less';

import React from 'react';
import classnames from 'classnames';

import FormattedMessage from '../FormattedMessage/FormattedMessage';

type Props = {
  message: SearchViewModelHeader
};

export default ({ message }: Props) => {
  // Yes, this is somewhat arbitrary. We tried...
  const isNoResults = message.parts[0].text === 'No results in ';

  return (
    <h1
      className={classnames({
        [styles.root]: true,
        [styles.noResults]: isNoResults
      })}
      data-automation="searchResultHeader"
    >
      <FormattedMessage message={message} />
    </h1>
  );
};
